import React from 'react';
import IconButton from 'material-ui/IconButton';
import Left from 'material-ui/svg-icons/navigation/chevron-left';
import WochitProgress from 'components/wochit-progress';
import {Link} from 'react-router';
import Header from 'components/header';
import './media-asset.css';

const style = {
    back: {
        position: 'absolute',
        left: 0,
        top: '50%',
        transform: 'translateY(-50%)'
    }
};

const VideoAsset =  function (props) {
    let src = props.urlCdn || props.url;
    let poster = props.poster || props.thumbnail;
    if (!/^(blob:|data:)/.test(src)) {
        src = '//' + src;
    }
    if (!/^(blob:|data:)/.test(poster)) {
        poster = '//' + poster;
    }
    return <div>
        <Header>
            <Link to="/" style={style.back}>
                <IconButton>
                    <Left color="#46C8f5"/>
                </IconButton>
            </Link>
            Media Preview
        </Header>
        <div className='wt-asset-container'>
            <div style={{position: 'relative'}}>
                <WochitProgress uploadStatus={props.uploadStatus} percentComplete={props.percentComplete} fileSize={props.fileSize}/>
                <video playsInline src={src} poster={poster} loop={props.loop} controls/>
            </div>
            {props.children}
        </div>
    </div>;
};

export default VideoAsset;